/* eslint-disable no-case-declarations */
import { CampaignGraphReport } from "../../constants/action-constants/CampaignGraphReportActionConstants";

const initialState = {
  // Campaign Media Demographic Stats -------------------------------
  campaignCityWiseMedias: {},
  campaignMediaDemographicStatsLoading: false,
  campaignMediaDemographicStatsError: "",

  // campaign graph pdf Report ------------------------------
  downloadCampaignGraphPdfReportLoading: false,
  downloadCampaignGraphPdfReportError: "",
  isCampaignGraphPdfReportDownloaded: false,
  campaignGraphPdfReportData: {},

  // campaign graph report form
  openDownloadCampaignGraphReportModal: false,

  // campaign graph report other cities info form
  openCampaignGraphReportOtherCitiesInfoModal: false,
  graphReportOtherCitiesInfoProcessDataObj: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    // Campaign Media Demographic Stats
    //-------------------------------------------------------------------------------------
    case CampaignGraphReport.GET_CAMPAIGN_MEDIA_DEMOGRAPHIC_STATS:
      return {
        ...state,
        campaignMediaDemographicStatsLoading: true,
      };

    case CampaignGraphReport.GET_CAMPAIGN_MEDIA_DEMOGRAPHIC_STATS_SUCCESS:
      return {
        ...state,
        campaignMediaDemographicStatsLoading: false,
        campaignCityWiseMedias: action.payload.cityWiseMedias,
      };

    case CampaignGraphReport.GET_CAMPAIGN_MEDIA_DEMOGRAPHIC_STATS_FAILURE:
      return {
        ...state,
        campaignMediaDemographicStatsLoading: false,
        campaignMediaDemographicStatsError: action.payload,
      };

    // Download Report pdf
    //-------------------------------------------------------------------------------------
    case CampaignGraphReport.DOWNLOAD_CAMPAIGN_GRAPH_PDF_REPORT:
      return {
        ...state,
        downloadCampaignGraphPdfReportLoading: true,
        isCampaignGraphPdfReportDownloaded: false,
      };
    case CampaignGraphReport.DOWNLOAD_CAMPAIGN_GRAPH_PDF_REPORT_SUCCESS: {
      const { isSentViaEmail, reportData } = action.payload || {};
      return {
        ...state,
        downloadCampaignGraphPdfReportLoading: false,
        isCampaignGraphPdfReportDownloaded: true,
        campaignGraphPdfReportData: { isSentViaEmail, reportData },
      };
    }
    case CampaignGraphReport.DOWNLOAD_CAMPAIGN_GRAPH_PDF_REPORT_FAILURE:
      return {
        ...state,
        downloadCampaignGraphPdfReportLoading: false,
        isCampaignGraphPdfReportDownloaded: false,
        campaignGraphPdfReportData: {},
        downloadCampaignGraphPdfReportError: action.payload,
      };
    case CampaignGraphReport.RESET_CAMPAIGN_GRAPH_PDF_REPORT:
      return {
        ...state,
        isCampaignGraphPdfReportDownloaded: false,
        campaignGraphPdfReportData: {},
      };

    // Download Graph Report Form
    case CampaignGraphReport.OPEN_DOWNLOAD_CAMPAIGN_GRAPH_REPORT_MODAL:
      return {
        ...state,
        openDownloadCampaignGraphReportModal: true,
      };

    case CampaignGraphReport.CLOSE_DOWNLOAD_CAMPAIGN_GRAPH_REPORT_MODAL:
      return {
        ...state,
        openDownloadCampaignGraphReportModal: false,
      };

    // Graph Report Other Cities Info Form
    case CampaignGraphReport.OPEN_CAMPAIGN_GRAPH_REPORT_OTHER_CITIES_INFO_MODAL:
      return {
        ...state,
        openCampaignGraphReportOtherCitiesInfoModal: true,
        graphReportOtherCitiesInfoProcessDataObj: action.payload.processDataObj,
      };

    case CampaignGraphReport.CLOSE_CAMPAIGN_GRAPH_REPORT_OTHER_CITIES_INFO_MODAL:
      return {
        ...state,
        openCampaignGraphReportOtherCitiesInfoModal: false,
        graphReportOtherCitiesInfoProcessDataObj: {},
      };

    default:
      return state;
  }
};
